"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _formik = require("formik");
var _utils = require("../../utils");
var _FormErrorMessage = _interopRequireDefault(require("../FormErrorMessage"));
var _PasswordStrength = _interopRequireDefault(require("../PasswordStrength"));
var _FormLabel = _interopRequireDefault(require("../FormLabel"));
var _Input = require("../Input");
var CreatePasswordFields = (0, _formik.connect)(function (props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var formik = props.formik,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    _props$passwordFieldN = props.passwordFieldName,
    passwordFieldName = _props$passwordFieldN === void 0 ? 'password' : _props$passwordFieldN,
    _props$newPassword = props.newPassword,
    newPassword = _props$newPassword === void 0 ? false : _props$newPassword,
    _props$visibleToggle = props.visibleToggle,
    visibleToggle = _props$visibleToggle === void 0 ? false : _props$visibleToggle,
    pwdOnchange = props.pwdOnchange,
    repeatPwdOnchange = props.repeatPwdOnchange;
  var errors = formik.errors,
    values = formik.values;
  var score = 0;
  if (values[passwordFieldName]) {
    score = (0, _utils.computePasswordStrength)(values[passwordFieldName]);
  }
  var showPasswordStrength = !errors[passwordFieldName] && values[passwordFieldName].length > 0;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    htmlFor: passwordFieldName
  }, newPassword ? t('createPassword.form.newPassword.label') : t('createPassword.form.password.label')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement(_Input.PasswordInput, {
    onChange: pwdOnchange,
    size: "lg",
    tabindex: "1",
    autoFocus: autoFocus,
    placeholder: "Password",
    name: passwordFieldName,
    visibleToggle: visibleToggle,
    className: "font-bold text-dark"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-4"
  }, showPasswordStrength ? /*#__PURE__*/_react["default"].createElement(_PasswordStrength["default"], {
    score: score
  }) : /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
    name: passwordFieldName
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    htmlFor: "confirmPassword"
  }, newPassword ? t('createPassword.form.confirmNewPassword.label') : t('createPassword.form.confirmPassword.label')), /*#__PURE__*/_react["default"].createElement(_Input.PasswordInput, {
    onChange: repeatPwdOnchange,
    size: "lg",
    tabindex: "1",
    placeholder: "Password",
    name: "confirmPassword",
    visibleToggle: visibleToggle,
    className: "font-bold text-dark"
  }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
    name: "confirmPassword"
  })));
});
var _default = exports["default"] = CreatePasswordFields;
//# sourceMappingURL=index.js.map